import { defineComponent as _defineComponent } from 'vue'
import { injectParentValidator } from '@/core/app.service';
import { computed, onMounted, ref, watch } from 'vue';
import UpdateUserRequest = Vertica.LouisPoulsen.Application.Account.Api.Requests.UpdateUserRequest;


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInformationUs',
  props: {
    states: null,
    value: null,
    labelNamespace: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: UpdateUserRequest): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    states: StateViewObject[]
    value?: UpdateUserRequest,
    labelNamespace: string
}




const form = ref<UpdateUserRequest>(props.value);

onMounted(() => {
    form.value.subRegion = null;
    form.value.subUnit = null;
});

// Inject validator
injectParentValidator();

watch(() => props.value, onChange, { deep: true });
function onChange() {
    form.value = props.value;
    emit('input', form.value);
}

const selectedState = computed<StateViewObject>({
    get() {
        return props.states.find(x => x.code === form.value.region);
    },
    set(value: StateViewObject) {
        form.value.region = value ? value.code : null;
        emit('input', form.value);
    }
});

return { __sfc: true,props, emit, form, onChange, selectedState }
}

})